/* eslint-disable camelcase */
import registerVuexModuleIfNotExists from 'src/utils/registerVuexModuleIfNotExists';
import orgs from './orgs'; // this is legacy, before app #8
import orgs_orgs from './orgs/orgs'; // starting app #8, this is the module for orgs
import apps from './apps/apps';
import preferences__user_preferences from '../platform/entities/user_preferences/user_preferences';
import products_products from './products/products'; // starting app #8, this is the module for products
import option_groups from './preferences/option_groups/option_groups';
import option_user_values from './preferences/option_user_values/option_user_values';
import comments_comments from './comments/comments';
import users_users from './users/users';
import users_users_native_ids from './users/usersNativeIds';
const localEntitiesToRegister = {
    'orgs.orgs': orgs_orgs,
    'apps.apps': apps,
    'orgs': orgs,
    'preferences.user_preferences': preferences__user_preferences,
    'comments.comments': comments_comments,
    'users.users': users_users,
    'users.users_native_ids': users_users_native_ids,
    'products.products': products_products,
    'preferences.option_groups': option_groups,
    'preferences.option_user_values': option_user_values,
};
export default function registerLocalEntitiesAtPlatformLevel() {
    for (const localEntityName in localEntitiesToRegister) {
        registerVuexModuleIfNotExists(localEntityName, localEntitiesToRegister[localEntityName]);
    }
}
